import React, { useState, useEffect } from 'react';
import { 
  AppBar, 
  Toolbar, 
  IconButton, 
  Box, 
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, NavLink } from 'react-router-dom';
import './Header.css';
import rafapLogo from '../../logo_afap.svg';
import leadLogo from '../../assets/lead-plus-logo.svg';

const Header = ({ toggleDrawer }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUserName(user.name || user.email || '');
    }
  }, []);

  const getInitial = () => {
    if (!userName) return 'U';
    if (userName.includes('@')) {
      return userName.split('@')[0].charAt(0).toUpperCase();
    }
    return userName.charAt(0).toUpperCase();
  };

  const handleUserMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    localStorage.removeItem('user');
    navigate('/');
  };

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  const navItems = [
    { text: 'Dashboard', path: '/dashboard' },
    { text: 'Extracción de datos', path: '/data-extraction' },
    { text: 'Batch Jobs', path: '/batch-jobs' },
    { text: 'Configuración', path: '/configuracion' },
    { text: 'Revisión Manual', path: '/manual-name-review' },
    { text: 'Estado de Servicios', path: '/system-health' },
  ];

  return (
    <AppBar position="fixed" className="header" elevation={0}>
      <Toolbar className="toolbar">
        <IconButton
          edge="start"
          color="primary"
          aria-label="menu"
          onClick={toggleDrawer}
          className="menu-button"
        >
          <MenuIcon />
        </IconButton>

        <Box className="left-section">
          <Box className="logos-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
            <img src={rafapLogo} alt="República AFAP" className="rafap-logo" />
            <img src={leadLogo} alt="Lead Plus" className="lead-logo" />
          </Box>
          <Box className="nav-links">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                {item.text}
              </NavLink>
            ))}
          </Box>
        </Box>

        <Box className="right-section">
          <Box className="user-menu">
            <Avatar 
              className="avatar"
              onClick={handleUserMenuClick}
            >
              {getInitial()}
            </Avatar>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
                  mt: 1.5,
                  '& .MuiMenuItem-root': {
                    fontFamily: '"Trasandina Web", Trasandina, sans-serif',
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <Typography>Cerrar Sesión</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;